'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _navigationSettingsPropType = require('./navigationSettingsPropType');

var _navigationSettingsPropType2 = _interopRequireDefault(_navigationSettingsPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _propTypes2.default.shape({
  units: _propTypes2.default.shape({
    temperature: _propTypes2.default.string,
    windSpeed: _propTypes2.default.string,
    tideHeight: _propTypes2.default.string,
    swellHeight: _propTypes2.default.string,
    surfHeight: _propTypes2.default.string
  }),
  navigation: _navigationSettingsPropType2.default
});


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/PropTypes/settingsPropType.js
// module id = 75
// module chunks = 0